import { urlConfig } from '@config/url.config';
import AbstractAPI from './Abstract.api';

export class SupportAPI extends AbstractAPI {
    async create(token: string, topic: string, content: string) {
        const pathname = 'support/create';
        const method = 'POST';
        const body = {
            token,
            topic,
            content,
        };
        try {
            return await this._request(pathname, method, body);
        } catch (e) {
            throw new Error(e);
        }
    }
}

export const supportAPI = new SupportAPI(urlConfig);
